/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import type { IconName } from '@/components/Icon';

export interface ResourceLink {
  label: string;
  href: string;
  description: string;
  icon: IconName;
  badge?: string;
}

export interface ResourceGroup {
  title: string;
  description: string;
  links: ResourceLink[];
}

export const RESOURCE_GROUPS: ResourceGroup[] = [
  {
    title: 'resources.groups.resources.title',
    description: 'resources.groups.resources.description',
    links: [
      {
        label: 'resources.links.dealerInfra.label',
        href: 'https://tis2web.akamai.gm.com/static/docs/dig211_us_en.pdf',
        description: 'resources.links.dealerInfra.description',
        icon: 'settings',
        badge: 'resources.badges.pdf',
      },
      {
        label: 'resources.links.techLink.label',
        href: 'https://gm-techlink.com/',
        description: 'resources.links.techLink.description',
        icon: 'spark',
      },
      {
        label: 'resources.links.mode6.label',
        href: 'https://gsi.ext.gm.com/gmspo/mode6/index.html',
        description: 'resources.links.mode6.description',
        icon: 'scan',
      },
      {
        label: 'resources.links.upfitter.label',
        href: 'https://www.gmupfitter.com/',
        description: 'resources.links.upfitter.description',
        icon: 'vehicle',
      },
    ],
  },
  {
    title: 'resources.groups.infotainment.title',
    description: 'resources.groups.infotainment.description',
    links: [
      {
        label: 'resources.links.usDealers.label',
        href: 'https://www.gmglobalconnect.com/',
        description: 'resources.links.usDealers.description',
        icon: 'external',
        badge: 'resources.badges.dealer',
      },
      {
        label: 'resources.links.caDealers.label',
        href: 'https://www.gmglobalconnect.com/',
        description: 'resources.links.caDealers.description',
        icon: 'external',
        badge: 'resources.badges.dealer',
      },
    ],
  },
];

export const RESOURCE_LINKS = RESOURCE_GROUPS.flatMap((group) => group.links);
